/// <amd-module name="Dashboards/Samples/WidgetListPanelSample" />
import * as React from "react";

import { WidgetTeamContext } from "Dashboards/WidgetContracts/WidgetProps";
import { DashboardWidgetListPanel } from "Dashboards/WidgetList/DashboardWidgetListPanel";
import { ITfsPageService } from "Tfs/Platform/Page";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";
import { getTeam } from "./DashboardsSamplesContext"

interface WidgetListPanelSampleProps {}

interface WidgetListPanelSampleState {
    showPickerPanel: boolean;
    projectId: string | undefined;
    teamContext: WidgetTeamContext | undefined;
}

export class WidgetListPanelSample extends VssComponent<WidgetListPanelSampleProps, WidgetListPanelSampleState> {
    constructor(props: WidgetListPanelSampleProps, context: IVssComponentContext) {
        super(props, context);
        this.state = this.getDefaultState();
    }

    public componentDidMount(): void {
        this.setState({
            projectId: this.getProjectContext(),
            teamContext: getTeam(this.context.pageContext)
        });
    }

    public render(): JSX.Element | null {
        if (this.state.teamContext == null) {
            return null;
        }

        return (
            <div className="in-situ-sample">
                <div>
                    <b>Early Preview</b>
                    <br />
                    Dashboards <b>WidgetListPanel</b> experiences allows for widgets to be selected and configured from a dashboard, for hosting in
                    user-configurable experiences other than a dashboard.
                </div>
                <Button primary onClick={this.showPicker} text={"Get Widget from Dashboards"} />

                {this.state.showPickerPanel && (
                    <DashboardWidgetListPanel
                        parentPageName={"WidgetListPanelSample"}
                        currentProjectId={this.state.projectId!}
                        onOk={this.dismissPicker}
                        onDismiss={this.dismissPicker}
                        teamContext={this.state.teamContext}
                    />
                )}
            </div>
        );
    }

    private getDefaultState(): WidgetListPanelSampleState {
        return {
            showPickerPanel: false,
            projectId: undefined,
            teamContext: undefined
        };
    }

    // Catalog Handlers and support code.
    private showPicker = () => {
        return this.setState({ showPickerPanel: true });
    };

    private dismissPicker = () => {
        return this.setState({ showPickerPanel: false });
    };

    private getProjectContext(): string {
        // Needed so Widgetlist can scope informational requests to current project.
        const pageServiceData = this.context.pageContext.getService<ITfsPageService>("ITfsPageService").getData();
        return (pageServiceData && pageServiceData.project && pageServiceData.project.id) || "";
    }
}
